import React, { useState } from 'react';
import { Gift } from 'react-bootstrap-icons';
import { useLocale } from '../i18n/LocaleContext';
import GiftDropsTab from './GiftDropsTab';
import PrizeWheelTab, { WheelGlyph } from './PrizeWheelTab';
import './GamesTab.scss';

// Challenges / Játékok — the brand's games, side by side: the gift chest in
// the galaxy (GiftDropsTab) and the prize wheel next to the store on the map
// (PrizeWheelTab). Only the chosen game is mounted, so only its socket / its
// polling (and the wheel's single WebGL preview) run.

export const GAMES = ['gifts', 'wheel'];
const STORAGE_KEY = 'portal_game';

function readGame() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (GAMES.includes(v)) return v;
  } catch {
    // storage blocked (Shopify admin iframe)
  }
  return 'gifts';
}

export default function GamesTab({ brand, canEdit = false }) {
  const { t } = useLocale();
  const [game, setGame] = useState(readGame);

  function choose(g) {
    setGame(g);
    try {
      localStorage.setItem(STORAGE_KEY, g);
    } catch {
      // not remembered
    }
  }

  function onKeyDown(e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const i = GAMES.indexOf(game);
    const next = GAMES[(i + (e.key === 'ArrowRight' ? 1 : GAMES.length - 1)) % GAMES.length];
    choose(next);
    document.getElementById(`game-tab-${next}`)?.focus();
  }

  return (
    <div className="games">
      <div className="games__switch" role="tablist" aria-label={t('games.label')} onKeyDown={onKeyDown}>
        {GAMES.map((g) => {
          const on = g === game;
          return (
            <button
              key={g}
              id={`game-tab-${g}`}
              type="button"
              role="tab"
              aria-selected={on}
              aria-controls={`game-panel-${g}`}
              tabIndex={on ? 0 : -1}
              className={`games__tab${on ? ' is-on' : ''}`}
              onClick={() => choose(g)}
            >
              <span className="games__icon" aria-hidden="true">
                {g === 'gifts' ? <Gift size={18} /> : <WheelGlyph size="xs" />}
              </span>
              <span className="games__text">
                <strong>{t(`games.${g}.title`)}</strong>
                <span>{t(`games.${g}.text`)}</span>
              </span>
            </button>
          );
        })}
      </div>
      <div id={`game-panel-${game}`} role="tabpanel" aria-labelledby={`game-tab-${game}`}>
        {game === 'wheel' ? <PrizeWheelTab brand={brand} canEdit={canEdit} /> : <GiftDropsTab brand={brand} canEdit={canEdit} />}
      </div>
    </div>
  );
}
